// AUTO-GENERATED by design/generate-tokens.mjs from design/tokens.json.
// DO NOT EDIT BY HAND. Regenerate via: node design/generate-tokens.mjs
// Source modes: raw colors=Mode 1, spacing=Mode 1, border radii=your_brand, semantic colors=your_brand, typography=your_brand, shadows=your_brand

export const colors = {
  "raw": {
    "amber": {
      "100": "#FEF3C7",
      "200": "#FDE68A",
      "300": "#FCD34D",
      "400": "#FBBF24",
      "50": "#FFFBEB",
      "500": "#F59E0B",
      "600": "#D97706",
      "700": "#B45309",
      "800": "#92400E",
      "900": "#78350F",
      "950": "#451A03"
    },
    "black": "#000000",
    "blue": {
      "100": "#DBEAFE",
      "200": "#BFDBFE",
      "300": "#93C5FD",
      "400": "#60A5FA",
      "50": "#EFF6FF",
      "500": "#3B82F6",
      "600": "#2563EB",
      "700": "#1D4ED8",
      "800": "#1E40AF",
      "900": "#1E3A8A",
      "950": "#172554"
    },
    "cyan": {
      "100": "#CFFAFE",
      "200": "#A5F3FC",
      "300": "#67E8F9",
      "400": "#22D3EE",
      "50": "#ECFEFF",
      "500": "#06B6D4",
      "600": "#0891B2",
      "700": "#0E7490",
      "800": "#155E75",
      "900": "#164E63",
      "950": "#083344"
    },
    "emerald": {
      "100": "#D1FAE5",
      "200": "#A7F3D0",
      "300": "#6EE7B7",
      "400": "#34D399",
      "50": "#ECFDF5",
      "500": "#10B981",
      "600": "#059669",
      "700": "#047857",
      "800": "#065F46",
      "900": "#064E3B",
      "950": "#022C22"
    },
    "fuchsia": {
      "100": "#FAE8FF",
      "200": "#F5D0FE",
      "300": "#F0ABFC",
      "400": "#E879F9",
      "50": "#FDF4FF",
      "500": "#D946EF",
      "600": "#C026D3",
      "700": "#A21CAF",
      "800": "#86198F",
      "900": "#701A75",
      "950": "#4A044E"
    },
    "gray": {
      "100": "#F3F4F6",
      "200": "#E5E7EB",
      "300": "#D1D5DB",
      "400": "#9CA3AF",
      "50": "#F9FAFB",
      "500": "#6B7280",
      "600": "#4B5563",
      "700": "#374151",
      "800": "#1F2937",
      "900": "#111827",
      "950": "#030712"
    },
    "green": {
      "100": "#DCFCE7",
      "200": "#BBF7D0",
      "300": "#86EFAC",
      "400": "#4ADE80",
      "50": "#F0FDF4",
      "500": "#22C55E",
      "600": "#16A34A",
      "700": "#15803D",
      "800": "#166534",
      "900": "#14532D",
      "950": "#052E16"
    },
    "indigo": {
      "100": "#E0E7FF",
      "200": "#C7D2FE",
      "300": "#A5B4FC",
      "400": "#818CF8",
      "50": "#EEF2FF",
      "500": "#6366F1",
      "600": "#4F46E5",
      "700": "#4338CA",
      "800": "#3730A3",
      "900": "#312E81",
      "950": "#1E1B4B"
    },
    "lime": {
      "100": "#ECFCCB",
      "200": "#D9F99D",
      "300": "#BEF264",
      "400": "#A3E635",
      "50": "#F7FEE7",
      "500": "#84CC16",
      "600": "#65A30D",
      "700": "#4D7C0F",
      "800": "#3F6212",
      "900": "#365314",
      "950": "#1A2E05"
    },
    "neutral": {
      "100": "#F5F5F5",
      "200": "#E5E5E5",
      "300": "#D4D4D4",
      "400": "#A3A3A3",
      "50": "#FAFAFA",
      "500": "#737373",
      "600": "#525252",
      "700": "#404040",
      "800": "#262626",
      "900": "#171717",
      "950": "#0A0A0A"
    },
    "orange": {
      "100": "#FFEDD5",
      "200": "#FED7AA",
      "300": "#FDBA74",
      "400": "#FB923C",
      "50": "#FFF7ED",
      "500": "#F97316",
      "600": "#EA580C",
      "700": "#C2410C",
      "800": "#9A3412",
      "900": "#7C2D12",
      "950": "#431407"
    },
    "pink": {
      "100": "#FCE7F3",
      "200": "#FBCFE8",
      "300": "#F9A8D4",
      "400": "#F472B6",
      "50": "#FDF2F8",
      "500": "#EC4899",
      "600": "#DB2777",
      "700": "#BE185D",
      "800": "#9D174D",
      "900": "#831843",
      "950": "#500724"
    },
    "purple": {
      "100": "#F3E8FF",
      "200": "#E9D5FF",
      "300": "#D8B4FE",
      "400": "#C084FC",
      "50": "#FAF5FF",
      "500": "#A855F7",
      "600": "#9333EA",
      "700": "#7E22CE",
      "800": "#6B21A8",
      "900": "#581C87",
      "950": "#3B0764"
    },
    "red": {
      "100": "#FFE2E2",
      "200": "#FECACA",
      "300": "#FCA5A5",
      "400": "#F87171",
      "50": "#FEF2F2",
      "500": "#EF4444",
      "600": "#DC2626",
      "700": "#B91C1C",
      "800": "#991B1B",
      "900": "#7F1D1D",
      "950": "#450A0A"
    },
    "rose": {
      "100": "#FFE4E6",
      "200": "#FECDD3",
      "300": "#FDA4AF",
      "400": "#FB7185",
      "50": "#FFF1F2",
      "500": "#F43F5E",
      "600": "#E11D48",
      "700": "#BE123C",
      "800": "#9F1239",
      "900": "#881337",
      "950": "#4C0519"
    },
    "sky": {
      "100": "#E0F2FE",
      "200": "#BAE6FD",
      "300": "#7DD3FC",
      "400": "#38BDF8",
      "50": "#F0F9FF",
      "500": "#0EA5E9",
      "600": "#0284C7",
      "700": "#0369A1",
      "800": "#075985",
      "900": "#0C4A6E",
      "950": "#082F49"
    },
    "slate": {
      "100": "#F1F5F9",
      "200": "#E2E8F0",
      "300": "#CBD5E1",
      "400": "#94A3B8",
      "50": "#F8FAFC",
      "500": "#64748B",
      "600": "#475569",
      "700": "#334155",
      "800": "#1E293B",
      "900": "#0F172A",
      "950": "#020617"
    },
    "stone": {
      "100": "#F5F5F4",
      "200": "#E7E5E4",
      "300": "#D6D3D1",
      "400": "#A8A29E",
      "50": "#FAFAF9",
      "500": "#78716C",
      "600": "#57534E",
      "700": "#44403C",
      "800": "#292524",
      "900": "#1C1917",
      "950": "#0C0A09"
    },
    "teal": {
      "100": "#CCFBF1",
      "200": "#99F6E4",
      "300": "#5EEAD4",
      "400": "#2DD4BF",
      "50": "#F0FDFA",
      "500": "#14B8A6",
      "600": "#0D9488",
      "700": "#0F766E",
      "800": "#115E59",
      "900": "#134E4A",
      "950": "#042F2E"
    },
    "violet": {
      "100": "#EDE9FE",
      "200": "#DDD6FE",
      "300": "#C4B5FD",
      "400": "#A78BFA",
      "50": "#F5F3FF",
      "500": "#8B5CF6",
      "600": "#7C3AED",
      "700": "#6D28D9",
      "800": "#5B21B6",
      "900": "#4C1D95",
      "950": "#2E1065"
    },
    "white": "#FFFFFF",
    "yellow": {
      "100": "#FEF9C3",
      "200": "#FEF08A",
      "300": "#FDE047",
      "400": "#FACC15",
      "50": "#FEFCE8",
      "500": "#EAB308",
      "600": "#CA8A04",
      "700": "#A16207",
      "800": "#854D0E",
      "900": "#713F12",
      "950": "#422006"
    },
    "zinc": {
      "100": "#F4F4F5",
      "200": "#E4E4E7",
      "300": "#D4D4D8",
      "400": "#A1A1AA",
      "50": "#FAFAFA",
      "500": "#71717A",
      "600": "#52525B",
      "700": "#3F3F46",
      "800": "#27272A",
      "900": "#18181B",
      "950": "#09090B"
    }
  },
  "semantic": {
    "DbBg Color": "#FCFCFC",
    "card": {
      "card": "#FFFFFF",
      "card foreground": "#020617"
    },
    "chart": {
      "area": {
        "amber": {
          "fill": "rgba(255, 237, 172, 0.7)",
          "fill 2": "rgba(254, 214, 153, 0.7)",
          "stroke": "#FFD230",
          "stroke 2": "#FE9A00"
        },
        "blue": {
          "fill": "rgba(191, 222, 255, 0.7)",
          "fill 2": "rgba(170, 204, 255, 0.7)",
          "stroke": "#8EC5FF",
          "stroke 2": "#3F8DFF"
        },
        "green": {
          "fill": "rgba(185, 251, 210, 0.7)",
          "fill 2": "rgba(130, 226, 169, 0.7)",
          "stroke": "#7BF1AB",
          "stroke 2": "#19D163"
        },
        "orange": {
          "fill": "rgba(253, 208, 156, 0.7)",
          "fill 2": "rgba(248, 176, 126, 0.7)",
          "stroke": "#FFB86A",
          "stroke 2": "#FF6900"
        },
        "purple": {
          "fill": "rgba(240, 224, 255, 0.7)",
          "fill 2": "rgba(222, 181, 255, 0.7)",
          "stroke": "#DAB2FF",
          "stroke 2": "#C67EFF"
        },
        "rose": {
          "fill": "rgba(255, 217, 222, 0.7)",
          "fill 2": "rgba(244, 145, 168, 0.7)",
          "stroke": "#FFA1AD",
          "stroke 2": "#FF4F79"
        },
        "teal": {
          "fill": "rgba(169, 243, 232, 0.7)",
          "fill 2": "rgba(124, 231, 220, 0.7)",
          "stroke": "#46EDD5",
          "stroke 2": "#07C0AC"
        }
      },
      "legacy": {
        "chart 1": "#1F77B4",
        "chart 2": "#FF7F0E",
        "chart 3": "#2CA02C",
        "chart 4": "#D62728",
        "chart 5": "#9467BD"
      },
      "static": {
        "amber": {
          "1": "#FFD230",
          "2": "#FE9A00",
          "3": "#E17100",
          "4": "#BB4D00",
          "5": "#973C00"
        },
        "blue": {
          "1": "#8EC5FF",
          "2": "#2B7FFF",
          "3": "#155DFC",
          "4": "#1447E6",
          "5": "#193CB8"
        },
        "green": {
          "1": "#7BF1A8",
          "2": "#00C951",
          "3": "#00A63E",
          "4": "#008236",
          "5": "#016630"
        },
        "orange": {
          "1": "#FFB86A",
          "2": "#FF6900",
          "3": "#F54A00",
          "4": "#CA3500",
          "5": "#9F2D00"
        },
        "purple": {
          "1": "#DAB2FF",
          "2": "#AD46FF",
          "3": "#9810FA",
          "4": "#8200DB",
          "5": "#6E11B0"
        },
        "rose": {
          "1": "#FFA1AD",
          "2": "#FF2056",
          "3": "#EC003F",
          "4": "#C70036",
          "5": "#A50036"
        },
        "teal": {
          "1": "#46EDD5",
          "2": "#00BBA7",
          "3": "#009689",
          "4": "#00786F",
          "5": "#005F5A"
        }
      }
    },
    "focus": {
      "ring": "#CBD5E1",
      "ring error": "#FCA5A5"
    },
    "general": {
      "Main Color": "#B32934",
      "Main Dark": "#8A1F28",
      "accent": "#F1F5F9",
      "accent foreground": "#0F172A",
      "background": "#FFFFFF",
      "border": "#E2E8F0",
      "destructive": "#DC2626",
      "foreground": "#414042",
      "input": "#FFFFFF",
      "muted": "#F1F5F9",
      "muted foreground": "#64748B",
      "primary": "#414042",
      "primary foreground": "#F8FAFC",
      "secondary": "#F1F5F9",
      "secondary foreground": "#0F172A"
    },
    "obra-shadn-docs": {
      "obra shadcn ui docs 1": "#FFFFFF",
      "obra shadcn ui docs 2": "#FFFFFF"
    },
    "popover": {
      "popover": "#000000",
      "popover foreground": "#FFFFFF"
    },
    "secondarry gold": "#A6813F",
    "sidebar": {
      "sidebar": "#F1F5F9",
      "sidebar accent": "#E2E8F0",
      "sidebar accent foreground": "#334155",
      "sidebar border": "#E2E8F0",
      "sidebar foreground": "#334155",
      "sidebar primary": "#0F172A",
      "sidebar primary foreground": "#F8FAFC",
      "sidebar ring": "#CBD5E1",
      "unofficial": {
        "sidebar muted": "#64748B"
      }
    },
    "unofficial": {
      "accent 0": "#F8FAFC",
      "accent 2": "#E2E8F0",
      "accent 3": "#CBD5E1",
      "backdrop": "rgba(51, 65, 85, 0.6)",
      "body background": "#FFFFFF",
      "border 0": "#F8FAFC",
      "border 1": "#F1F5F9",
      "border 3": "#CBD5E1",
      "border 4": "#94A3B8",
      "border 5": "#64748B",
      "contrast": "#000000",
      "destructive border": "#EF4444",
      "destructive foreground": "#DC2626",
      "destructive subtle": "#FEF2F2",
      "foreground alt": "#334155",
      "ghost": "rgba(255, 255, 255, 0.0001)",
      "ghost foreground": "#334155",
      "ghost hover": "rgba(0, 0, 0, 0.05)",
      "mid (DEPRECATED)": "#64748B",
      "mid alt": "#475569",
      "outline": "rgba(255, 255, 255, 0.1)",
      "outline active": "rgba(51, 65, 85, 0.05)",
      "outline hover": "rgba(51, 65, 85, 0.0333)",
      "primary hover": "#334155",
      "secondary hover": "#F8FAFC"
    }
  }
} as const;

export const spacing = {
  "absolute": {
    "0": 0,
    "0_5": 2,
    "1": 4,
    "10": 40,
    "11": 44,
    "12": 48,
    "14": 56,
    "16": 64,
    "1_5": 6,
    "2": 8,
    "20": 80,
    "24": 96,
    "28": 112,
    "2_5": 10,
    "3": 12,
    "32": 128,
    "36": 144,
    "3_5": 14,
    "4": 16,
    "40": 160,
    "44": 176,
    "48": 192,
    "5": 20,
    "52": 208,
    "56": 224,
    "6": 24,
    "60": 240,
    "64": 256,
    "7": 28,
    "72": 288,
    "8": 32,
    "80": 320,
    "9": 36,
    "96": 384,
    "infinite": 9999
  }
} as const;

export const radii = {
  "absolute": {
    "radius-10": 10,
    "radius-12": 12,
    "radius-16": 16,
    "radius-2": 2,
    "radius-24": 24,
    "radius-32": 32,
    "radius-4": 4,
    "radius-6": 6,
    "radius-8": 8,
    "radius-infinite": 9999
  },
  "semantic": {
    "rounded-2xl": 16,
    "rounded-3xl": 24,
    "rounded-full": 9999,
    "rounded-lg": 8,
    "rounded-md": 6,
    "rounded-none": 0,
    "rounded-sm": 4,
    "rounded-xl": 12,
    "rounded-xs": 2
  }
} as const;

export const typography = {
  "font definitions": {
    "font-family-body": "Inter",
    "font-family-headings": "Inter",
    "font-family-monospace": "Menlo",
    "font-family-sans": "Inter",
    "font-family-serif": "Inter"
  },
  "heading 1": {
    "font size": 48,
    "line height": 48,
    "weight": "Semibold"
  },
  "heading 2": {
    "font size": 30,
    "line height": 30,
    "weight": "Semibold"
  },
  "heading 3": {
    "font size": 24,
    "heading 3 weight": "Semibold",
    "line height": 28.8
  },
  "heading 4": {
    "font size": 20,
    "line height": 24,
    "weight": "Semibold"
  },
  "paragraph": {
    "paragraph bold weight": "Medium",
    "paragraph font size": 16,
    "paragraph line height": 24,
    "paragraph mini font size": 12,
    "paragraph mini line height": 16,
    "paragraph mini spacing": 12,
    "paragraph small font size": 14,
    "paragraph small line height": 21,
    "paragraph small spacing": 14,
    "paragraph spacing": 16,
    "paragraph weight": "Regular"
  }
} as const;

export const shadows = {
  "2xl": {
    "blur": 50,
    "color": "rgba(0, 0, 0, 0.25)",
    "spread": 12,
    "x": 0,
    "y": 25
  },
  "2xs": {
    "blur": 0,
    "color": "rgba(0, 0, 0, 0.05)",
    "spread": 0,
    "x": 0,
    "y": 1
  },
  "lg": {
    "color": "rgba(0, 0, 0, 0.1)",
    "shadow 1": {
      "blur": 15,
      "spread": -3,
      "x": 0,
      "y": 10
    },
    "shadow 2": {
      "blur": -4,
      "spread": 6,
      "x": 0,
      "y": 4
    }
  },
  "md": {
    "color": "rgba(0, 0, 0, 0.1)",
    "shadow 1": {
      "blur": 6,
      "spread": -1,
      "x": 0,
      "y": 4
    },
    "shadow 2": {
      "blur": 4,
      "spread": -2,
      "x": 0,
      "y": 2
    }
  },
  "sm": {
    "color": "rgba(0, 0, 0, 0.1)",
    "shadow 1": {
      "blur": 3,
      "spread": 0,
      "x": 0,
      "y": 1
    },
    "shadow 2": {
      "blur": 2,
      "spread": -1,
      "x2": 0,
      "y": 1
    }
  },
  "xl": {
    "color": "rgba(0, 0, 0, 0.1)",
    "shadow 1": {
      "blur": 25,
      "spread": -5,
      "x": 0,
      "y": 20
    },
    "shadow 2": {
      "blur": -6,
      "spread": 10,
      "x": 0,
      "y": 8
    }
  },
  "xs": {
    "blur": 2,
    "color": "rgba(0, 0, 0, 0.05)",
    "spread": 0,
    "x": 0,
    "y": 1
  }
} as const;

export type Colors = typeof colors;
export type Spacing = typeof spacing;
export type Radii = typeof radii;
export type Typography = typeof typography;
export type Shadows = typeof shadows;

// Convenience type helpers for autocomplete on common paths.
export type SemanticColorPath = keyof Colors['semantic'];
export type RawColorPath = keyof Colors['raw'];
export type SpacingScale = keyof Spacing[keyof Spacing] | keyof Spacing;
